import { Component, OnInit, Inject, HostBinding } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    templateUrl: './dlg-preferences.component.pug',
    styleUrls: ['./dlg-preferences.component.less'],
})
export class DlgWorldPreferencesComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DlgWorldPreferencesComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
    }

    onClose() {
        this.dialogRef.close(false);
    }

    onChange(preferences) {
        if (!this.data.change) {
            return;
        }

        this.data.change(preferences);
    }
}
